import { graphql } from '../gql';

export const submitPreviousPurchaseMutation = graphql(`
  mutation submitPreviousPurchase($gbswl: GBSWL!) {
    registerPreviousPurchase(input: { previousPurchase: $gbswl }) {
      id
    }
  }
`);
